import React from 'react';
import { GET } from '../HttpClient';


// usage ==> const { response, isLoading, errorMessages, fetchData } = useListItem({url: '/api/items/'});
export default function useListItem ({url, params, usePagination = false}) {
  const [response, setResponse] = React.useState(
    usePagination ? 
    { 
      links: {
        next: null,
        previous: null,
      },
      total: 0,
      pages: 0,
      results: [] 
    } : []
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);

  const fetchData = async (additional_params) => {
    setIsLoading(true);
    try {
      const response = await GET(url, { ...params, ...additional_params });
      setResponse(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setIsLoading(false);
    }
  };

  return { response, isLoading, errorMessages, fetchData };
}